import { render, staticRenderFns } from "./CorporateLenderList.vue?vue&type=template&id=656d91e9&"
import script from "./CorporateLenderList.vue?vue&type=script&lang=js&"
export * from "./CorporateLenderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports